import type { ReactNode } from 'react';

const COLUMNS = {
  3: 'grid grid-cols-1 gap-4 sm:grid-cols-3',
  4: 'grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4',
};

/** A page's KPI row: `StatTile`s (or `StatTileSkeleton`s) above the list card (DESIGN.md §7.2). */
export function StatsRow({
  ariaLabel,
  columns = 4,
  children,
}: {
  ariaLabel: string;
  columns?: 3 | 4;
  children: ReactNode;
}) {
  return (
    <section aria-label={ariaLabel} className={COLUMNS[columns]}>
      {children}
    </section>
  );
}
